<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="testimonial-slider">
        <div class="swiper-container testimonial-slider__container">
          <div class="swiper-wrapper testimonial-slider__wrapper">
            <swiper :options="swiperOption">
              <div class="swiper-slide">
                <div class="testimonial-slider__single wow move-up">
                  <div class="testimonial-slider__media">
                    <img src="../assets/img/team/avatar-01-120x120.png" class="img-fluid" alt="">
                  </div>
                  <div class="testimonial-slider__text">
                    “Seitdem ich das MHP-Portal nutze konnte ich mir endlich die lang ersehnte Kreufahrt leisten.”
                  </div>
                  <div class="testimonial-slider__author">
                    <h6 class="name">Renate M. (68)</h6>
                    <span class="designation">Kunstliebhaberin</span>
                  </div>
                  <b-form-rating v-model="stars5" readonly variant="warning"></b-form-rating>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="testimonial-slider__single wow move-up">
                  <div class="testimonial-slider__media">
                    <img src="../assets/img/team/avatar-07-120x120.png" class="img-fluid" alt="">
                  </div>
                  <div class="testimonial-slider__text">
                    “Es hat leider echt lange gedauert bis sich ein Käufer für mein Werk gefunden hat...aber trotzdem hat es sich gelohnt.”
                  </div>
                  <div class="testimonial-slider__author">
                    <h6 class="name">Gertrud S. (61)</h6>
                    <span class="designation">Kunstliebhaberin</span>
                  </div>
                  <b-form-rating v-model="stars4" readonly variant="warning"></b-form-rating>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="testimonial-slider__single wow move-up">
                  <div class="testimonial-slider__media">
                    <img src="../assets/img/team/avatar-02-120x120.png" class="img-fluid" alt="">
                  </div>
                  <div class="testimonial-slider__text">
                    “Einfach super! Meine Bibliothek ist nun so wie ich sie mir schon immer gewünscht habe!”
                  </div>
                  <div class="testimonial-slider__author">
                    <h6 class="name">Burkhard L. (38)</h6>
                    <span class="designation">Faksimile-Sammler</span>
                  </div>
                  <b-form-rating v-model="stars5" readonly variant="warning"></b-form-rating>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="testimonial-slider__single wow move-up">
                  <div class="testimonial-slider__media">
                    <img src="../assets/img/team/avatar-03-120x120.png" class="img-fluid" alt="">
                  </div>
                  <div class="testimonial-slider__text">
                    “Ich kann meinen Kunden nun sehr seltene Werke anbieten. Sie sind seitdem noch zufriedener. “
                  </div>
                  <div class="testimonial-slider__author">
                    <h6 class="name">Silvia W. (56)</h6>
                    <span class="designation">Kunsthändlerin</span>
                  </div>
                  <b-form-rating v-model="stars5" readonly variant="warning"></b-form-rating>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="testimonial-slider__single wow move-up">
                  <div class="testimonial-slider__media">
                    <img src="../assets/img/team/avatar-05-120x120.png" class="img-fluid" alt="">
                  </div>
                  <div class="testimonial-slider__text">
                    “Ohne den Kundenservice ist das Einpflegen der Daten in das System nicht so einfach... Daher nur drei Sterne von mir.“
                  </div>
                  <div class="testimonial-slider__author">
                    <h6 class="name">Bernhard W. (41)</h6>
                    <span class="designation">Kunsthändlerin</span>
                  </div>
                  <b-form-rating v-model="stars3" readonly variant="warning"></b-form-rating>
                </div>
              </div>
            </swiper>
          </div>
        </div>
        <div class="swiper-pagination swiper-pagination-1 section-space--mt_60"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestimonialTwo',
  data() {
    return {
      stars3: 3,
      stars4: 4,
      stars5: 5,
      swiperOption: {
        speed: 800,
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        breakpoints: {
          1499: {
            slidesPerView: 3
          },

          991: {
            slidesPerView: 2
          },

          767: {
            slidesPerView: 1
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.b-rating {
  border: 0;
  width: 160px;
  margin: 0 auto;
}
</style>